// Middleware
import GuestMiddleware from '@middleware/GuestMiddleware';

// Layouts
import LayoutDefault from '@layouts/LayoutDefault';

export default {
    path: '/',
    component: LayoutDefault,
    children: [
        {
            path: '',
            name: 'home',
            component: () => import('@pages/index/PageHome'),
            meta: {
                middleware: GuestMiddleware,
            },
        },
        {
            path: 'agencies',
            name: 'agencies',
            component: () => import('@pages/index/PageAgencies'),
            meta: {
                title: 'titles.agencies',
            },
        },
        {
            path: 'ai',
            name: 'ai',
            component: () => import('@pages/index/PageAi'),
            meta: {
                title: 'titles.ai',
            },
        },

        {
            path: 'pricing',
            name: 'pricing',
            component: () => import('@pages/index/PagePricing'),
            meta: {
                title: 'titles.pricing',
            },
        },
        {
            path: 'faq',
            name: 'faq',
            component: () => import('@pages/index/PageFaq'),
            meta: {
                title: 'titles.faq',
            },
        },
        {
            path: 'contact',
            name: 'contact',
            component: () => import('@pages/index/PageContact'),
            meta: {
                title: 'titles.contact_us',
            },
        },

        {
            path: 'ltd',
            name: 'ltd',
            component: () => import('@pages/index/PageLtd'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.lifetime_deal',
            },
        },
        {
            path: 'brand',
            name: 'brand',
            component: () => import('@pages/mockups/PageMockups'),
        },
    ],
};